

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"13","height":"2","viewBox":"0 0 13 2","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M12.3257 1.59635C12.1703 1.75046 11.9605 1.83736 11.7416 1.83826L1.72354 1.83824C1.26412 1.80269 0.920479 1.40142 0.956015 0.941983C0.987742 0.531935 1.31351 0.20617 1.72354 0.174462L11.7711 0.144964C12.2317 0.12979 12.6173 0.490857 12.6325 0.951421C12.6331 0.969742 12.6331 0.988044 12.6325 1.00637C12.6164 1.23703 12.5053 1.45067 12.3257 1.59635Z","fill":"#594A66"}, []), "\n"]);
};

        